import { Navigate } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import { hasUserAccess } from 'src/auth/permission-access';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export function PermissionGuard({ children, access }) {
  const { user } = useAuthContext();

  if (!hasUserAccess(user, access)) {
    return <Navigate to={paths.dashboard.root} replace />;
  }

  return <>{children}</>;
}
